<template>
  <div v-if="items.length>0">
    <q-table
        flat
        square
        separator="horizontal"
        :hide-header="$q.screen.lt.md"
        :data="items"
    >
      <template v-slot:top>
        <span class="text-subtitle1">{{title}}</span>
      </template>
      <template v-slot:header>
        <q-tr class="text-center text-subtitle2">
          <td>طرف معامله</td>
          <td>بانک</td>
          <td>شماره چک</td>
          <td>تاریخ</td>
          <td>تاریخ سررسید</td>
          <td>قیمت</td>
        </q-tr>
      </template>
      <template v-slot:body="props">
        <q-tr v-if="!$q.screen.lt.md" class="text-center" :props="props">
          <td class="text-center">
            <q-chip square icon="person" :label="props.row.Name" clickable
                    @click="showCustomerInfo(props.row)"/>
          </td>
          <td class="text-center">{{ props.row.AccountName }}</td>
          <td class="text-center">
            <q-chip square :label="props.row.ChequeNum" color="red" text-color="white"/>
          </td>
          <td class="text-center">{{ changeDateFormat(props.row.Date) }}</td>
          <td class="text-center">
            <q-chip v-if="changeDateFormat(props.row.ExpiryDate)!=='Invalid date'" square :label="changeDateFormat(props.row.ExpiryDate)" color="red" text-color="white"/>
          </td>
          <td class="text-center">
            <q-chip square :label="props.row.Fee.toLocaleString()" color="green" text-color="white"/>
          </td>
        </q-tr>
      </template>
    </q-table>
    <q-dialog :maximized="$q.screen.lt.md" v-model="customerInfoDialog">
      <CustomerInfo :selected-customer="selectedCustomer"/>
    </q-dialog>
  </div>
</template>

<script>
import CustomerInfo from "@/components/customers/CustomerInfo";
import {mapActions} from "vuex";

export default {
  name: "CheckDetails",
  components: {CustomerInfo},
  props: {
    items: {
      type: []
    },
    title:{
      type: String
    }
  },
  data() {
    return {
      customerInfoDialog: false,
      selectedCustomer: '',
    }
  },
  methods:{
    ...mapActions({
      setCustomerInfo: 'Customers/get_customer_info_by_code'
    }),
    showCustomerInfo(row) {
      this.setCustomerInfo(row.Code).then((res) => {
        this.selectedCustomer = res.data[0]
        this.customerInfoDialog = true
      })
    }
  }
}
</script>

<style scoped>

</style>